import styled from "@emotion/styled";
import { css } from '@emotion/react';

import { checkBookingAvailabilityByTime } from '../../../utils/util';

import { parseTime, roundToPointOfHourTime, getDateParts, convertDecimalToTime } from '../helpers';

import { useCalendarContext } from "../../../contexts/Calendar";
import { useNewEvent } from "../../../contexts/NewEvent";

import { parseDivisions } from './helpers';

// import { darken } from '@mui/material/styles';

import { Tooltip, darken } from "@mui/material";

const TimelineDivision = styled.div`
  height: ${props => props.$height || '6rem'};
  /* border-bottom: 1px ${props => props.$dashed ? "dashed" : "solid"} ${props => props.theme.colors.border}; */
  border-bottom: 1px solid ${props => darken(props.theme.colors.border, .1)};
  border-left: ${props => props.$track !== 0 ? `1px solid ${darken(props.theme.colors.border, .1)}` : "none"};
  background-color: #fcfcfc;
  cursor: pointer;
  /* position: relative; */

  &:before {
    content: "${props => props.$time || ""}";
    position: relative;
    top: -2rem;
    left: 50%;
    width: 5rem;
    height: 2rem;
    background-color: ${props => props.theme.colors.darkBg};
    display: none;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 5px;
    transform: translateX(-50%);
  }

  &:hover {
    background-color: ${props => darken(props.theme.colors.darkBg, .2)};

    &:before {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  ${props => props.$enabled && css/* closed */`
    background-color: #fcfcfc;
    cursor: pointer;
  `}

  ${props => props.$non_work && css/* closed */`
    background: #d8d8d8;
    cursor: help;
    /* opacity: 0.7; */

  `}

   ${props => props.$disabled && css/* closed */`
    background: #ffe6e6;
    cursor: not-allowed;

    &:hover {
      background-color: #ffe6e6;
    }
  `}

  ${props => props.$warning && css/* closed */`
    background: #fffacd;
    cursor: help;
  `}
`;

const getTime = ({event, id, rowHeight, beginShow, division}) => {
    let div = document.getElementById(`${id}`)
    let trackHeight = div.getBoundingClientRect().top;
    let yinDiv = event.clientY - trackHeight;
    let time = (yinDiv / (rowHeight * 10));
    let divide = 60 / parseDivisions(division);
    let { minutes, hours } = roundToPointOfHourTime(time + beginShow, divide);

    return { hours, minutes };
  }

  const PrintTimelineDisplay = ({
    hours = 24, 
    track,  
    workingHours = {}, 
    date,
    stylist,
    id
  }) => {

  const { setting } = useCalendarContext() || {};

  let { view_density, hourly_divisions, display_hours } = setting?.data || {};

  const { createNewEvent } = useNewEvent();
  
  let rowHeightSetting = +view_density || 24;
  const divisions = parseDivisions(hourly_divisions);
  const rowHeight = rowHeightSetting / divisions + 'rem';

  let beginShow = +display_hours?.start ? +display_hours?.start : 0;
  let endShow = +display_hours?.end ? +display_hours?.end : 24;

  const createEvent = (e) => {
    let { minutes, hours } = getTime({
      event: e, 
      id, 
      rowHeight: rowHeightSetting, 
      beginShow, 
      division: divisions
    });
    let { year, day, month } = getDateParts(date);
    createNewEvent(new Date(year, month, day, hours, minutes), stylist);
  }
  
  return (
     Array.from({ length: hours * divisions }, (_, i) => i + 1).map((index) => {
      let hourDivision = index / divisions; // Start from 0, not 1

      let checkAvailability = checkBookingAvailabilityByTime(date, hourDivision, setting);

      let not_active = workingHours?.active ? false : true;
      
      const startTime = parseTime(workingHours?.start_time);
      const endTime = parseTime(workingHours?.end_time);

      const timeLabel = convertDecimalToTime(hourDivision, 60 / divisions);
      
      // Check if current hour division is within working hours
      let disableHour = hourDivision <= startTime || hourDivision > endTime;

      if (not_active) disableHour = true;

      if (hourDivision <= beginShow || hourDivision > endShow) return null;
      return (
        // <Tooltip title={`${timeLabel}`} arrow key={index}>
        <TimelineDivision 
          onClick={createEvent}
          key={index} 
          $height={rowHeight} 
          $dashed={index % 2} 
          $track={track}
          $non_work={disableHour}
          $time={timeLabel}
          {...checkAvailability}
        />
        // </Tooltip>
      );
    })
  )
};


export default PrintTimelineDisplay;